function GetMarkName(Degree, MarkType) {
    let degree = parseFloat(Degree);
    //alert(Degree+'  '+degree);
    let shortMark;
    let longMark;
    if (degree >= 98 && degree <= 100) {
        shortMark = "أ+";
        longMark = "ممتاز مرتفع";
    } else if (degree >= 95 && degree <= 97.99) {
        shortMark = "أ";
        longMark = "ممتاز";
    } else if (degree >= 92 && degree <= 94.99) {
        shortMark = "ب+";
        longMark = "جيد جدا مرتفع";
    } else if (degree >= 88 && degree <= 91.99) {
        shortMark = "ب";
        longMark = "جيد جدا";
    } else if (degree >= 84 && degree <= 87.99) {
        shortMark = "ج+";
        longMark = "جيد مرتفع";
    } else if (degree >= 80 && degree <= 83.99) {
        shortMark = "ج";
        longMark = "جيد";
    } else if (degree < 80) {
        shortMark = "د";
        longMark = "راسب";
    }
    if (MarkType === "short") {
        return shortMark;
    } else if (MarkType === "long") {
        return longMark;
    }
}

function GetMarkMony(MarkShortName, MurtaqaID) {
    // return 0;
    // let degree = parseFloat(Degree);
    let murtaqaID = parseFloat(MurtaqaID);

    let murtaqaBaseMoney = [
        {id: 0, money: 0},
        {id: 1, money: 75},
        {id: 2, money: 90},
        {id: 3, money: 100},
        {id: 4, money: 115},
        {id: 5, money: 125},
        {id: 6, money: 140},
        {id: 7, money: 150},
        // {id: 8, money: 165},
    ];
    // return murtaqaBaseMoney[murtaqaID].money;
    // let m1 = 75,
    //     m2 = 90,
    //     m3 = 100,
    //     m4 = 115,
    //     m5 = 125,
    //     m6 = 140,
    //     m7 = 150,
    //     m8 = 165,
    //     m9 = 165,
    //     m10 = 165;

    let MoneyAdd;
    if (MarkShortName === "أ+") {
        MoneyAdd = 25;
    } else if (MarkShortName === "أ") {
        MoneyAdd = 0;
    } else if (MarkShortName === "ب" || MarkShortName === "ب+") {
        MoneyAdd = -5;
    } else if (MarkShortName === "ج" || MarkShortName === "ج+") {
        MoneyAdd = -10;
    } else if (MarkShortName === "د") {
        return 0;
    }
    return murtaqaBaseMoney[murtaqaID].money + MoneyAdd;

}

//مكافأة المعلم
function GetMarkMonyForTeacher(MarkShortName, MurtaqaID) {
    // return 0;
    // let degree = parseFloat(Degree);
    let murtaqaID = parseFloat(MurtaqaID);
    // let m1 = 30,
    //     m2 = 40,
    //     m3 = 50,
    //     m4 = 60,
    //     m5 = 90,
    //     m6 = 100,
    //     m7 = 110,
    //     m8 = 120;
    let murtaqaBaseMoney = [
        {id: 0, money: 0},
        {id: 1, money: 15},
        {id: 2, money: 20},
        {id: 3, money: 25},
        {id: 4, money: 30},
        {id: 5, money: 35},
        {id: 6, money: 40},
        {id: 7, money: 45},
        // {id: 8, money: 50},
    ];

    let MoneyAdd;
    if (MarkShortName === "أ+" || MarkShortName === "أ") {
        MoneyAdd = 0;
    } else if (MarkShortName === "ب" || MarkShortName === "ب+") {
        MoneyAdd = -2;
    } else if (MarkShortName === "ج" || MarkShortName === "ج+") {
        MoneyAdd = -5;
    } else if (MarkShortName === "د") {
        return 0;
    }
    return murtaqaBaseMoney[murtaqaID].money + MoneyAdd;
    // switch (murtaqaID) {
    //     case 1:
    //         return (m1 + MoneyAdd);
    //     case 2:
    //         return (m2 + MoneyAdd);
    //     case 3:
    //         return (m3 + MoneyAdd);
    //     case 4:
    //         return (m4 + MoneyAdd);
    //     case 5:
    //         return (m5 + MoneyAdd);
    //     case 6:
    //         return (m6 + MoneyAdd);
    //     case 7:
    //         return (m7 + MoneyAdd);
    //     case 8:
    //         return (m8 + MoneyAdd);
    // }
}

//مكافأة المجمع
function GetMarkMonyForEdarah(MarkShortName, MurtaqaID) {
    // return 0;
    // let degree = parseFloat(Degree);
    let murtaqaID = parseFloat(MurtaqaID);
    // let m1 = 15,
    //     m2 = 20,
    //     m3 = 25,
    //     m4 = 30,
    //     m5 = 35,
    //     m6 = 40,
    //     m7 = 45,
    //     m8 = 50;

    let murtaqaBaseMoney = [
        {id: 0, money: 0},
        {id: 1, money: 15},
        {id: 2, money: 20},
        {id: 3, money: 25},
        {id: 4, money: 30},
        {id: 5, money: 35},
        {id: 6, money: 40},
        {id: 7, money: 45},
        // {id: 8, money: 50},
    ];
    let MoneyAdd;
    if (MarkShortName == "أ+" || MarkShortName == "أ") {
        MoneyAdd = 0;
    } else if (MarkShortName == "ب" || MarkShortName == "ب+") {
        MoneyAdd = -2;
    } else if (MarkShortName == "ج" || MarkShortName == "ج+") {
        MoneyAdd = -5;
    } else if (MarkShortName == "د") {
        return 0;
    }
    return murtaqaBaseMoney[murtaqaID].money + MoneyAdd;
    // switch (murtaqaID) {
    //     case 1:
    //         return (m1 + MoneyAdd) ;
    //     case 2:
    //         return (m2 + MoneyAdd) ;
    //     case 3:
    //         return (m3 + MoneyAdd) ;
    //     case 4:
    //         return (m4 + MoneyAdd) ;
    //     case 5:
    //         return (m5 + MoneyAdd) ;
    //     case 6:
    //         return (m6 + MoneyAdd) ;
    //     case 7:
    //         return (m7 + MoneyAdd) ;
    //     case 8:
    //         return (m8 + MoneyAdd) ;
    // }
}


//خاص بمرتقى الفاتحة
function GetMarkName20(Degree, MarkType) {
    let degree = parseFloat(Degree);
    //alert(Degree+'  '+degree);
    let shortMark;
    let longMark;
    if (degree >= 90 && degree <= 100) {
        shortMark = "أ";
        longMark = "ممتاز";
    } else if (degree >= 80 && degree <= 89.99) {
        shortMark = "ب";
        longMark = "جيد جدا";
    } else if (degree >= 75 && degree <= 79.99) {
        shortMark = "ج";
        longMark = "جيد";
    } else if (degree < 75) {
        shortMark = "د";
        longMark = "راسب";
    }
    if (MarkType == "short") {
        return shortMark;
    } else if (MarkType == "long") {
        return longMark;
    }
}

//خاص بمرتقى الفاتحة
function GetMarkMony20(MarkShortName) {
    return 0;
    let money = 0;
    if (MarkShortName == "أ") {
        money = 5000;
    } else if (MarkShortName == "ب") {
        money = 4700;
    } else if (MarkShortName == "ج") {
        money = 4500;
    } else if (MarkShortName == "د") {
        money = 0;
    }
    return money / 2;
}

//خاص بمرتقى الفاتحة
//مكافأة المعلم
function GetMarkMonyForTeacher20(MarkShortName) {
    // تلغى مكافأة المعلم من الإحصاءات لأنها تصرف من جائزة الحلافي في الحفل
    let money = 0;
    if (MarkShortName == "أ") {
        money = 100;
    } else if (MarkShortName == "ب") {
        money = 100;
    } else if (MarkShortName == "ج") {
        money = 100;
    } else if (MarkShortName == "د") {
        money = 0;
    }
    return money;
}

//صغية الريجكس للتاريخ الهجري
/*function HijriDate(value) {
 try{
 return /(^13|^14)\d\d([- \/.\\])([1-9]|0[1-9]|1[012])(\2)([1-9]|0[1-9]|[12][0-9]|30)$/.test(value);
 }catch(er){
 alert(err.message);
 }
 }*/

//اضهار تنبيه إذا كان الفورم خطأ
function showError() {
    $('#form1,#form2').parsley({
        listeners: {
            onFormSubmit: function (isFormValid, event) {
                if (!isFormValid) {
                    alertify.error("يرجى التحقق من البيانات");
                } else {
                    $(".EnableDisable").removeAttr("disabled");
                }
            }
        }
    });
}


//مكافأة سلم البراعم
function GetBra3mMoney(Darajah) {
    return '0';//بعد قرار إيقاف مكافئات البراعم
    switch (Darajah) {
        case '1':
            return '10';
        case '2':
            return '20';
        case '3':
            return '30';
        case '4':
            return '40';
        case '5':
            return '50';

    }
}

function ExamPoints(ErtiqaID, Degree) {
    //alert(ErtiqaID);
    //alert(Degree);
    ErtiqaP = 0;
    switch (ErtiqaID) {
        case '1' :
            ErtiqaP = 1.5;
            break;
        case '2' :
            ErtiqaP = 2;
            break;
        case '3' :
            ErtiqaP = 2.5;
            break;
        case '4' :
            ErtiqaP = 3;
            break;
        case '5' :
            ErtiqaP = 3.5;
            break;
        case '6' :
            ErtiqaP = 4;
            break;
        case '7' :
            ErtiqaP = 4.5;
            break;
        case '8' :
            ErtiqaP = 5;
            break;
        case '9' :
            ErtiqaP = 5;
            break;
        case '10' :
            ErtiqaP = 5;
            break;
    }

    if (ErtiqaID == 9) return parseFloat((Degree / 250) * ErtiqaP).toFixed(2);//تجويد
    if (ErtiqaID == 10) return parseFloat((Degree / 200) * ErtiqaP).toFixed(2);//بدون تجويد

    return parseFloat((Degree / 100) * ErtiqaP).toFixed(2);
}

function roundMe(n, sig) {
    if (n === 0) return 0;
    let mult = Math.pow(10, sig - Math.floor(Math.log(n < 0 ? -n : n) / Math.LN10) - 1);
    return Math.round(n * mult) / mult;
}


function checkSA(id) {

    let numericExpression = /^[0-9]+$/;

    id = id.trim();

    if (!id.match(numericExpression)) return false;

    if (id.length !== 10) return false;

    let index0 = id.substr(0, 1);

    if (index0 != 2 && index0 != 1 && index0 != 4) return false;

    let sum = 0;
    for (let i = 0; i < 10; i++) {
        if (i % 2 == 0) {

            let padStr = str_pad((id.substr(i, 1) * 2), 2, "0", "STR_PAD_LEFT");

            sum = sum + parseInt(padStr.substr(0, 1)) + parseInt(padStr.substr(1, 1));
        } else {
            sum = sum + parseInt(id.substr(i, 1));
        }
    }

    return sum % 10 ? false : true;
}


function str_pad(input, pad_length, pad_string, pad_type) {
    let half = '',
        pad_to_go;

    let str_pad_repeater = function (s, len) {
        let collect = '',
            i;

        while (collect.length < len) {
            collect += s;
        }
        collect = collect.substr(0, len);

        return collect;
    };

    input += '';
    pad_string = pad_string !== undefined ? pad_string : ' ';

    if (pad_type != 'STR_PAD_LEFT' && pad_type != 'STR_PAD_RIGHT' && pad_type != 'STR_PAD_BOTH') {
        pad_type = 'STR_PAD_RIGHT';
    }
    if ((pad_to_go = pad_length - input.length) > 0) {
        if (pad_type == 'STR_PAD_LEFT') {
            input = str_pad_repeater(pad_string, pad_to_go) + input;
        } else if (pad_type == 'STR_PAD_RIGHT') {
            input = input + str_pad_repeater(pad_string, pad_to_go);
        } else if (pad_type == 'STR_PAD_BOTH') {
            half = str_pad_repeater(pad_string, Math.ceil(pad_to_go / 2));
            input = half + input + half;
            input = input.substr(0, pad_length);
        }
    }

    return input;
}

function checkSaudiId(input_id) {
    const input = document.getElementById(input_id);
    const saudi_id = input.value;

    const warning_p = '<p id="wrong_id" style="display: none;color: red;padding: 10px 5px;">السجل المدني غير صحيح.</p>';

    if (!$("#wrong_id").length) {
        $(warning_p).insertAfter(input);
    }

    $('#wrong_id').hide();
    if (saudi_id.length == 10) {
        if (!checkSA(saudi_id)) {
            $('#wrong_id').show();
        }
    }
}

function export_table_to_excel(table_id) {
    let tab_text = "<table border='1px'>";
    const tab = document.getElementById(table_id); // id of table

    let j = 0;
    for (j = 0; j < tab.rows.length; j++) {
        tab_text = tab_text + "<tr >" + tab.rows[j].innerHTML + "</tr>";
    }

    tab_text = tab_text + "</table>";

    tab_text = tab_text.replace(/<a[^>]*>|<\/a>/gi, "");//remove if u want links in your table
    tab_text = tab_text.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
    tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params


    const sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));

    return (sa);
}

function selectElementContents(el) {
    let body = document.body, range, sel;
    if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
            range.selectNodeContents(el);
            sel.addRange(range);
        } catch (e) {
            range.selectNode(el);
            sel.addRange(range);
        }
    } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
    }

}